/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import OperatorCard from "../../components/Card/Operator";
import AppointementCard from "../../components/Card/Appointement";
import DoctorCard from "../../components/Card/Doctor";
import Queuemodal from "../../components/Modal";
import QueuepatientDetailshell from "./shell";
import * as R from "ramda";
import postService from "../../services/httpService";
import userTrackService from "../../services/usertrack-service";
import Storage from "../../services/local-store";
import {
  Modal,
  Input,
  Spin,
  Popover,
  Select,
  Button,
  Tooltip,
  Tabs
} from "antd";
import searchIcon from "../../assets/images/searchicon.svg";
import DoctorDetailsCard from "../common/DoctorDetailsCard";
import { SyncOutlined } from '@ant-design/icons';
import IdleTimer from "react-idle-timer";
import moment from "moment";
import networkList from "./../../constants/networkList";
// const { websocket_url2 } = networkList;



// const url = new URL(websocket_url2);
// const host = url.host;
// const sockets = new WebSocket('ws://'+host);

const $ = require("jquery");
const { Search } = Input;
const antIcon = (
  // <Icon
  //   type="sync"
  //   style={{ fontSize: 48, left: "-19px", bottom: "10px" }}
  //   spin
  // />

<SyncOutlined style={{ fontSize: 48, position: 'relative', left: '-19px', bottom: '10px' }} spin />

); 


class OperatorView extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      item:[],
      date: new Date(),
      patients: "",
      QueueList: "",
      billingPatients: "",
      appointmentPatients:"",
      allpatients: [],
      appointmentPatientDetails: "",
      showPatients: true,
      showAppointments: false,
      latestCardId: null,
      latestContainer: null,
      latestDropIndex: null,
      isLoading: false,
      queueDoctors: "",
      isvitalsRequire_null: false,
      vitalsModalvisible: false,
      vitalsRequired: null,
      confirmLoading: false,
      roomnamefromOperator: "",
      files: "",
      ModalError: false,
      searchVal: "",
      searchVal1: "",
      lastRefreshedAt: null,
      selectedOption: "patients",
  
      
    };
    this.idleTimer = null
    this.onIdle = this._onIdle.bind(this)
    this.onAction = this._onAction.bind(this)
   
  }

  _onIdle() {
    this.newPatientsData("refresh");
  
    this.queuePatientsData();
    console.log('IDLE')
  };
  _onAction(e) {
    const { lastRefreshedAt } = this.state;
    console.log('_onAction')
    // let getLastActiveTime = this.idleTimer.getLastActiveTime();
    // console.log('time getLastActiveTime', moment(getLastActiveTime).format('DD-MM-YYYY HH:mm')) 
    let now = moment()
    let last = moment(lastRefreshedAt)
    let diff = now.diff(last, 'seconds')
    if (diff > 7) {
      this.newPatientsData("refresh");
      this.queuePatientsData();
      // console.log('REFRESHEDDD')
    }
    // console.log('REFRESH last',last)
    // console.log('REFRESH diff',diff)
  }

  componentDidMount() {
    // console.log("propppps",this.props);
    // sockets.onopen = () => {
    //   console.log('WebSocket connection established HIS.');
    //  };
    // sockets.onmessage = (event) => {
    //       const message = event.data;
    //       // let obj=JSON.parse(message);
    //       console.log(`Received message from server HIS: ${message}`);
    //       this.refreshData();
    //   }
    //    sockets.onclose = () => {
    //     console.log('WebSocket connection closed HIS.');
      
    //   };
    //    sockets.onerror = (error) => {
    //     console.error('WebSocket error HIS:', error);
    //    }; 
    
    this.refreshData();
    this.horizantalScroll();
   
    // this.setState({isLoading:false});
    // this.setState({lastRefreshedAt: null});
    // console.log(this.props);
    // this.interval = setInterval(this.autoRefresh.bind(this), 5000);
    this.newPatientsData();

    this.queuePatientsData();
  }


 

  autoRefresh() {
    this.newPatientsData("refresh");
    this.queuePatientsData();
  }

  horizantalScroll() {
    let scaleWidth = 0;
    $(".card-dynamic").each(function (ele) {
      scaleWidth += $(this).outerWidth(true);
    });
    //console.log(scaleWidth);
  }

  modalChanges() {
    this.setState({ visible: false });
  }

  showModal = () => {
    this.setState({ visible: true });
  };
  showPatients = () => {
    this.setState({ showPatients: true, showAppointments: false });
  };
  showAppointments = () => {
    this.setState({ showPatients: false, showAppointments: true });
  };
  refreshCard = () => {
    if (this.state.showPatients) {
      this.showPatients();
    }
    this.newPatientsData();
  };
   componentWillMount() {
    //componentDidMount() {
    window.ondragover = function (e) {
      e.preventDefault();
      return false;
    };
    window.ondrop = function (e) {
      e.preventDefault();
      return false;
    };
    // this.storePatientsData();
    this.setState({ isLoading: true });
    this.newPatientsData();
    this.queuePatientsData();
    //this.getQueueDoctors();
  }

  componentDidUpdate(prevProps, prevState) {
   
    $(".custom-container").css({
      height:
        $(window).outerHeight() -
        ($("header").outerHeight() + $(".breadCrums").outerHeight()),    
      "padding-bottom": "0px",    
    });
    this.horizantalScroll();
    $(".b-card").css({
      height:
        $(".custom-container").outerHeight() - $(".h-card").outerHeight() - 31,
    });
    $(".b-card-scroll").css({
      height:
        // $(".b-card").outerHeight() - $(".b-card-footer").outerHeight() - 10,
        $(".b-card").outerHeight() - 10,
    });
    $("footer").hide();
    // this.interval = setInterval(() => {
    //     this.newPatientsData()
    // }, 180000);
    let { files, vitalsRequired, roomnamefromOperator } = this.state;
    if (
      prevState.vitalsRequired === null &&
      prevState.vitalsRequired !== vitalsRequired
    ) {
      vitalsRequired !== null && this.onFileDrop(files, roomnamefromOperator);
    }
  }
 

  componentWillUnmount() {
    $(".custom-container").removeAttr("style");
    $("footer").show();
    // clearInterval(this.interval);
  }

  // storePatientsData() {
  //     postService('newPatientsList', 'GET', 'null').then(res => {
  //         if (res) {
  //             this.setState((state) => ({patients: res.data, billingPatients: res.data.billing, appointemntPatients: res.data.appointments}));
  //         }
  //     });
  //     postService('getQueuesBasedOnService', 'GET', 'null').then(res => {
  //         if (res) {
  //             this.setState((state) => ({QueueList: res.data}));
  //         }
  //     });
  // }
  getQueueDoctors() {
    postService("getQueueDoctors", "GET", "null").then((res) => {
      if (res) {
        this.setState({ queueDoctors: res.data });
        // console.log("GetQueueDoctors------------>>>>>>>>",res.data);
      }
    });
  }
  activateLoader() {
    this.setState({ isLoading: true });
  }
  deActivateLoader() {
    this.setState({ isLoading: false });
  }
  setlastRefreshedAt(lastRefreshedAt) {
    this.setState({ lastRefreshedAt: lastRefreshedAt })
  }
  newPatientsData(type) {
    type !== "refresh" && this.activateLoader();
    postService("newPatientsList", "GET", "null").then((res) => {
      if (res) {
        this.deActivateLoader();
        // console.log("responsed data",res.data);
        this.setState((state) => ({
          patients: res.data,
          // billingPatients: res.data.billing,
          // appointemntPatients: res.data.appointments,
          // allpatients: res.data.billing,
          // allappointemntPatients: res.data.appointments,
          // lastRefreshedAt: moment()
          appointmentPatientDetails: res.data && res.data.appointments ? res.data.appointments : [],
          allpatients: res.data && res.data.billing ? res.data.billing : [],
          // allappointemntPatients: res.data && res.data.appointments ? res.data.appointments : [],
          lastRefreshedAt: moment(),
        

        }));
      }
      // console.log("Is this dispalying?");
      // console.log("GGGGGGGGGGGGGGGGGggggg",this.state.appointmentPatientDetails,this.state.allpatients);
    });
  }

  queuePatientsData() {
    postService("getQueuesBasedOnService", "GET", "null").then((res) => {
      this.deActivateLoader();
      if (res) {
        if (res.status && res.data.length) {
          let sortByDisplayOrder = res.data.sort(function (a, b) {
            return (a.display_order === null) - (b.display_order === null) || +(a.display_order > b.display_order) || -(a.display_order < b.display_order);
          });
          // console.log("SORTED LIST",sortByDisplayOrder);
          this.setState({ QueueList: sortByDisplayOrder });
          // console.log("QQuueue LIST------------",this.state.QueueList);
        }
        else {
          this.setState({ QueueList: res.data });
          // console.log("QQuueue LIST11------------",this.state.QueueList);
        }
      }
    });
  }
  refreshData() {
    console.log("refresh data----HIS");
    this.newPatientsData();
    this.queuePatientsData();
    // this.getQueueDoctors();
  }
 
  refreshQueueListData() {
    this.queuePatientsData();
  }
  getPatients(props, key) {
    let PatientsObj = R.pick(["patients"], props);
    let emptyReq = "";
    if (!R.isEmpty(PatientsObj)) {
      let Patients = PatientsObj.patients;
      if (!R.isEmpty(Patients)) {
        let PatientsObj = R.pick([key], Patients);
        if (!R.isEmpty(PatientsObj)) {
          if (!R.isEmpty(PatientsObj[key])) {
            let Patients = PatientsObj[key];
            return Patients;
          }
        }
      }
    }
    return emptyReq;
  }

  getQueueList(props) {
    let QueuesObj = R.pick(["QueueList"], props);
    let emptyReq = "";
    if (!R.isEmpty(QueuesObj)) {
      let Queues = QueuesObj.QueueList;
      return Queues;
    }
    return emptyReq;
  }
  isvitalsRequire_nullornot(is_vitals_require) {
    let value = is_vitals_require && is_vitals_require === null ? true : false;
    this.setState({
      isvitalsRequire_null: value,
    });
  }

  checkQType(files, item) {
    // here, item is queue with details
    let QType =
      this.state.QueueList.length && this.state.QueueList[0].queue_type;
    // console.log("checkQType item", item);
    QType === "Radiology" && this.onFileDrop(files, item);
    QType === "OPD Consultation" &&
      this.vitalsModalvisibility(true, files, item);
  }
  onFileDrop(files, item) {
//  console.log("\\\\\\\\\\\\\\onFileDroppppp",item);
    this.setState({ roomnamefromOperator: item });
    let { QueueList, vitalsRequired } = this.state;
    let QType = QueueList.length && QueueList[0].queue_type;
    this.getQueueDoctors();
    let doctors_maste_data=this.state.queueDoctors;
    // here, lid :- card (which is dragged) details when dragging, cid:- room name from which card dragged , item:- room details i.e queue details to which card dragged, latestDropIndex :-, QueueList:- total list of rooms and their details
    let lid = this.state.latestCardId;
    let cid = this.state.latestContainer;
    let latestDropIndex = this.state.latestDropIndex;
    // console.log("ondropped items request...");
    // console.log("ondropped", lid, cid, item, latestDropIndex, QueueList);
    let toQueuePatients = item.patients;
    // console.log("LLLLLLLLLLLLLLLLLLLLLLLLLL",this.state.queueDoctors,"KKKKKKKKKKKK",doctors_maste_data)
    QueueList = QueueList.filter((s) => s.display_status != "1");
    
    if (item !== null) {
      let belowDropIndex = null;
      let ccard = QueueList.filter((s) => s.roomnumber == item.roomnumber);
      let fromqueuelistid = "";
      let toqueuelistid = "";
      let fromservicegroup = "";
      let toservicegroup = "";
      let toroomnumber = "";
      let fromroomnumber = "";
      let patientservicegroup = "";
      let toqueueServicegroups = "";
      let fromqueueServicegroups = "";
      if (ccard[0] !== undefined && ccard[0] !== null) {
       toqueuelistid = ccard[0].queuelistid;
        toservicegroup = ccard[0].service_group_name;
        toroomnumber = ccard[0].doctor_id;
        toqueueServicegroups = ccard[0].service_groups;
      }
      if (cid !== undefined && cid !== null) {
       let sourcequeueobj = QueueList.filter((s) => s.roomnumber == cid);
        // console.log("cid same queue");
        // console.log(sourcequeueobj);
        if (sourcequeueobj[0] !== undefined && sourcequeueobj[0] !== null) {
         fromqueuelistid = sourcequeueobj[0].queuelistid;
          fromservicegroup = sourcequeueobj[0].service_group_name;
          fromroomnumber = sourcequeueobj[0].doctor_id;
          fromqueueServicegroups = sourcequeueobj[0].service_groups;
        }
        if (lid.service_groupid !== undefined && lid.service_groupid !== null) {
          patientservicegroup = lid.service_groupid;
        }
      } 
      else {
        // console.log("lid dif queue");
        // console.log(lid);
        if (lid.service_groupid !== undefined && lid.service_groupid !== null) {
           patientservicegroup = lid.service_groupid;
        }
        if (lid.room_number !== undefined && lid.room_number !== null) {
          fromroomnumber = lid.room_number;
        }
      }

      let obj = {
        patientId: lid.id,
        queueListId: toqueuelistid,
        fromqueueListId: fromqueuelistid,
      };
      // console.log(obj,fromroomnumber,toroomnumber);
      // console.log(toqueueServicegroups,patientservicegroup);
      if (fromroomnumber === toroomnumber) {
        this.setState({ latestDropIndex: null, isLoading: true });
        let Userlogobj = {
          user: JSON.parse(Storage.get("user")),
          action: "drag and drop",
          date: new Date(),
          meta: obj,
        };
        userTrackService(Userlogobj);
        postService("assignPatientToRoom", "POST", { data: obj }).then(
          (res) => {
            let Userlogobjres = {
              user: JSON.parse(Storage.get("user")),
              action: "drag and drop - response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            //this.setState({ isLoading: false });
            //if (res) {
            this.refreshData();
            if (fromqueuelistid != "" && fromqueuelistid != null) {
              let fromqueuerefresh = {
                queueListId: fromqueuelistid,
              };
              this.refreshMultipleQueues(fromqueuerefresh, "assign");
            }
            this.refreshMultipleQueues(obj, "assign");
            //}
          }
        );
      } else if (fromroomnumber !== toroomnumber) {
        if (toqueueServicegroups.includes(patientservicegroup)) {
          if (
            QType === "OPD Consultation" &&
            lid.is_vitals_require === null &&
            (lid.is_investigation === null || lid.is_investigation === undefined) &&
            vitalsRequired === null
          ) {
            // console.log("qwe1", lid.is_vitals_require, vitalsRequired);
            // console.log("qwerty1", item.queue_doctor_id, lid);
            if (item.queue_doctor_id === lid.service_id) {
               if (fromroomnumber && toroomnumber) {
                this.setState({
                  vitalsModalvisible: false,
                  vitalsRequired: lid.is_vitals_require,
                });
              } else {
                
                 // console.log("item and lid>>>>>>>>>>>>>>>>>>>>>>>>>",item, lid,"vitals==",item.vitals_required);
                this.setState({ vitalsModalvisible: true });
                let option=null;
                if(item.vitals_required){
                  option="YES"
                }
                else{
                  option="NO"
                }
                this.isVitalsRequired(
            
                  // item.id //patient card
                  this.state.latestCardId.id,option
                );
              }
            } else {
              this.setState({ latestDropIndex: null });
              Modal.error({
                zIndex: 1040,
                maskClosable: false,
                centered: true,
                title: "Error",
                content:
                  "Oops! you are trying to drop a patient in different room.",
              });
            }
          } else {
            // console.log("qwe2", lid.is_vitals_require, vitalsRequired);
            // console.log("qwerty2", item.queue_doctor_id, lid);
             if (
              QType === "OPD Consultation" &&
              // item.doctorname !== lid.service_name
              item.queue_doctor_id !== lid.service_id
            ) {
              Modal.error({
                zIndex: 1040,
                maskClosable: false,
                centered: true,
                title: "Error",
                content:
                  "Oops! you are trying to drop a patient in different room.",
              });
            } else {
              this.setState({ latestDropIndex: null, isLoading: true });
              let Userlogobj = {
                user: JSON.parse(Storage.get("user")),
                action: "drag and drop",
                date: new Date(),
                meta: obj,
              };
              userTrackService(Userlogobj);
              postService("assignPatientToRoom", "POST", { data: obj }).then(
                (res) => {
                  let Userlogobjres = {
                    user: JSON.parse(Storage.get("user")),
                    action: "drag and drop - response",
                    date: new Date(),
                    meta: res,
                  };
                  userTrackService(Userlogobjres);
                  this.setState({ isLoading: false, vitalsRequired: null });
                  //if (res) {
                  this.refreshData();
                  if (fromqueuelistid != "" && fromqueuelistid != null) {
                   let fromqueuerefresh = {
                      queueListId: fromqueuelistid,
                    };
                    this.refreshMultipleQueues(fromqueuerefresh, "assign");
                  }
                  this.refreshMultipleQueues(obj, "assign");
                  //}
                }
              );
            }
          }
        } else {
          this.setState({ latestDropIndex: null });
          Modal.error({
            zIndex: 1040,
            maskClosable: false,
            centered: true,
            title: "Error",
            content:
              "Oops! you are trying to drop a patient in different room.",
          });
        }
      }
    } else {
      // console.log("onfile drop list elsecase");
      // console.log(lid);
      let obj1 = {
        patientId: lid.id,
      };
      // postService('removePatientFromQueue', 'POST', { "data": obj1 }).then(res => {
      //     if (res) {
      //         this.refreshData();
      //     }
      // });
    }
  }
  dropover11() { }
  onDragEnter() { }
  setLatestCard(r, cont) {
    this.setState({ latestCardId: r, latestContainer: cont });
  }
  setLatestDropIndex(i) {
    // console.log("dropindex----" + i);
    this.state.latestDropIndex = i;
    // this.state.latestContainer = cont;
  }
  getSearchResults1(value) {
    let actualAppointments = this.state.appointmentPatientDetails || [];
    this.setState({ searchVal1: value });
    if (value) {
      let searchKey = value;
      let searchresults = actualAppointments.filter((s) => {
        if (
          R.includes(R.toLower(searchKey), R.toLower(s.name ? s.name : "null"))
        ) {
          return s;
        } else if (
          R.includes(R.toLower(searchKey), R.toLower(s.umr ? s.umr : "null"))
        ) {
          return s;
        } else if (
          R.includes(R.toLower(searchKey), R.toLower(s.service_name ? s.service_name : "null"))
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.casetype ? s.casetype : "null")
          )
        ) {
          return s;
        }
      });
      this.setState({ appointmentPatients: searchresults });
    } else {
      this.setState({ appointmentPatients: actualAppointments });
    }
  }
  getSearchResults(value) {
    let actualPatients = this.state.allpatients || [];
    this.setState({ searchVal: value });
    if (value) {
      let searchKey = value;
      let searchresults = actualPatients.filter((s) => {
        if (
          R.includes(R.toLower(searchKey), R.toLower(s.name ? s.name : "null"))
        ) {
          return s;
        } else if (
          R.includes(R.toLower(searchKey), R.toLower(s.umr ? s.umr : "null"))
        ) {
          return s;
        } else if (
          R.includes(R.toLower(searchKey), R.toLower(s.service_name ? s.service_name : "null"))
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.patienttype ? s.patienttype : "null")
          )
        ) {
          return s;
        }
      });
      this.setState({ billingPatients: searchresults });
    } else {
      this.setState({ billingPatients: actualPatients });
    }
  }
  getSearchAppResults(value) {
    let actualAppPatients = this.state.allappointemntPatients || [];
    if (value) {
      let searchKey = value;
      let searchresults = actualAppPatients.filter((s) => {
        if (
          R.includes(R.toLower(searchKey), R.toLower(s.name ? s.name : "null"))
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.phonenumber ? s.phonenumber : "null")
          )
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.patienttype ? s.patienttype : "null")
          )
        ) {
          return s;
        }
      });
      this.setState({ appointemntPatients: searchresults });
    } else {
      this.setState({ appointemntPatients: actualAppPatients });
    }
  }

  refreshMultipleQueues(queueitem, action) {
    let queuelistid = queueitem.queuelistid || queueitem.queueListId;
    if (queuelistid !== undefined && queuelistid !== null) {
      let obj = {
        queueListId: queuelistid,
        action: action,
      };
      postService("refreshQueueById", "POST", { data: obj }).then((res) => {
        console.log("refreshQueueById-----");
        if (res) {
          let queueinfo = res.data || {};
          let QueueList = this.state.QueueList;
          let objIndex = QueueList.findIndex(
            (obj) => obj.queuelistid == queuelistid
          );
          QueueList[objIndex] = queueinfo;
          this.setState({ QueueList: QueueList, lastRefreshedAt: moment() });
        }
      });
    }
  }
  vitalsModalvisibility = (value, files, item) => {
    let roomname = item; //queue with details
    this.setState({
      vitalsModalvisible: value,
      roomnamefromOperator: roomname,
      files: files,
    });
  };
  vitalshandleOk = () => {
    this.setState({
      confirmLoading: false,
      vitalsModalvisible: false,
    });
  };
  vitalshandleCancel = () => {
    this.setState({
      vitalsModalvisible: false,
    });
  };
  vitalshandleOKCancel = () => {
    this.state.vitalsRequired === "YES" || this.state.vitalsRequired === "NO"
      ? this.setState({
        vitalsModalvisible: false,
        ModalError: false,
      })
      : this.setState({
        ModalError: true,
      });
  };
 
 
  // vitalsCheckandassignRoom() {
  //   // console.log("vitalsCheckandassignRoom", this.state.vitalsRequired);
  //   // this.props.item.
  //   // this.state.vitalsRequired === "NO" && this.assignRoom();
  // }
  // isVitalsRequired(value) {
  //   this.setState({ vitalsRequired: value });
  // }

  // isVitalsRequired(event, id, option) {
    isVitalsRequired( id, option) {
    // let yesOrNo = event.target.id;
    let yesOrNo = option;
    let patientId = id;
    // console.log("Patientid and vitals-----",typeof yesOrNo,"and", typeof "NO","lll",patientId,option);

    // (yesOrNo === "NO" || yesOrNo === "YES") &&
    //   this.onFileDrop(this.state.files, this.state.roomnamefromOperator);
    let obj = {
      data: {
        patient_id: patientId,
        is_vitals_required: yesOrNo,
      },
    };
// console.log("vitals_id==============","2===",yesOrNo,"3====",obj.data.patient_id);
    postService("setPatientVitalsFlag", "POST", obj).then((res) => {
      // console.log("setPatientVitalsFlag", res);
      if (res) {
        this.setState({ vitalsRequired: yesOrNo, vitalsModalvisible: false });
      }
    });
  }

  render() {
    //console.log("state values----"); console.log(this.state);
    
    let showPatients = this.state.showPatients;
    let showAppointments = this.state.showAppointments;
    let displayPatients = this.state.billingPatients
      ? this.state.billingPatients
      : this.state.allpatients;
       //Storage.getJson('billingPatients');
    let appointemntPatients = this.state.appointemntPatients || [];
    let QueueList = this.state.QueueList || []; // Storage.getJson('QueueList');
    let QType = QueueList.length && QueueList[0].queue_type;
    let queueDoctors = this.state.queueDoctors || [];
    let appointmentpatientlist=this.state.appointmentPatients?this.state.appointmentPatients:this.state.appointmentPatientDetails || [];
    // console.log("OPView QueueList", QueueList);
    // console.log(R.sortBy(R.prop('roomnumber'), QueueList));
    // console.log("queueDoctors======",queueDoctors);
     //console.log("showpatients================",this.state.appointmentPatientDetails );
 
   
    if (!R.isEmpty(QueueList)) {
      QueueList = QueueList.filter((s) => s.display_status != "1");
      // QueueList = R.sortBy(R.prop("roomnumber"), QueueList);
    }
    const department_ids = QueueList.map(item => ({dept_ids:item.department_ids,roomnumber:item.roomnumber,quelist_id:item.doctor_id,doctor_name:item.doctorname,doctor_id:item.queue_doctor_id,unit_id:item.unit_id}));
    // console.log("spcl--",specialization_code_data); 
    // console.log("showpatients1111================",QueueList);
    let vitalsOptions = ["YES", "NO"];
    showPatients = this.state.showPatients;

    return (
      <div className="row q-p-details" >
        {/* {console.log("QType render", QType)} */}
          <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1500 * 60} // 1 minute
        />  

        <div className="col-3 col-lg-3 col-md-5" >
          <div className="card h-card p-3">
            <div className="row">
              {this.state.showPatients && (
                <React.Fragment>
                  <div className="col-10 my-auto">
                    <p>New Patient</p>
                  </div>
                  <div className="col-2 my-auto">
                    <button className="q-p-add" onClick={this.showModal} />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
          {/* new patients list */}
         
          
              <div className="card mt-2 b-card pr-1" >
            
              {/* <div style={{display:"flex"}} className="mt-2">
            <div style={{border:"1px solid gray",cursor: 'pointer',padding:"10px 10px",borderRadius:"5px",margin:"0px 3px",backgroundColor: this.state.selectedOption === 'patients' ? '#8c2ba4' : 'inherit',color: this.state.selectedOption === 'patients' ? 'white' : 'black',borderRadius: this.state.selectedOption === 'patients' ? '5px 5px 0px 0px' : '5px',}} onClick={() => this.setState({ selectedOption: 'patients' })}>Patients</div>

            <div style={{border:"1px solid gray",cursor: 'pointer',padding:"10px",borderRadius:"5px",backgroundColor: this.state.selectedOption === 'appointments' ? '#8c2ba4' : 'inherit',color: this.state.selectedOption === 'appointments' ? 'white' : 'black',borderRadius: this.state.selectedOption === 'appointments' ? '5px 5px 0px 0px' : '5px',}}  onClick={() => this.setState({ selectedOption: 'appointments' })}>Appointments</div>
          </div> */}
          <Tabs activeKey={this.state.selectedOption} onChange={(key) => this.setState({ selectedOption: key })} className="b-card-scroll mb-3 patients">
  <Tabs.TabPane tab="Patients" key="patients" style={{padding:'5px'}}  >
    
    <div>
                    <div className="row mb-3">
                        <div className="col-10 pr-0">
                 
                          <Search
                              value={this.state.searchVal}
                              placeholder="Search here"
                              allowClear={true}
                    // onSearch={this.getSearchResults.bind(this)}
                              onChange={(e) => this.getSearchResults(e.target.value)}
                            />
                        </div>
              
                        <Popover
                          overlayClassName="popover-custom"
                          placement="top"
                          title={""}
                          content={"Refresh"}
                        >
                        <figure
                          className="col m-auto"
                          onClick={this.refreshCard.bind(this)}
                        >
                          <img
                            src="/assets/images/icons/refresh.png"
                            alt="refresh"
                            draggable={false}
                          />
                        </figure>
                        </Popover>
                  </div>
            
            {/* <div className="b-card-scroll mb-3"> */}
            <div>
           
              {
              
               displayPatients && displayPatients.map((item) => {
                
                // const intervalId = setInterval(() => {
                  return (
                    <div>
                  { this.state.QueueList ?(
                    
                      <OperatorCard
                        setLatestCard={this.setLatestCard.bind(this)}
                        props={this.state}
                        vitalsModalvisible={this.vitalsModalvisibility}
                        vitalsRequired={this.state.vitalsRequired}
                        {...this.props}
                        roomId={null}
                        item={item}
                        value1={false}
                        datavalue={"false"}
                        refreshData={this.refreshData.bind(this)}
                        activateLoader={this.activateLoader.bind(this)}
                        deActivateLoader={this.deActivateLoader.bind(this)}
                        refreshMultipleQueues={this.refreshMultipleQueues.bind(
                          this
                        )}
                        QType={QType && QType}
                      />):(<p></p>)}

                    </div>
                  );
              //   }, 2000);
              //   setTimeout(() => {
              //     clearInterval(intervalId);
              // }, 2000);
                })}
            </div> </div>
  
  </Tabs.TabPane>
  <Tabs.TabPane tab="Appointments" key="appointments" className="appointments">
   
    <div >
              <div className="row mb-3">
                <div className="col-10 pr-0">
                 
                  <Search
                    value={this.state.searchVal1}
                    placeholder="Search here"
                    allowClear={true}
                    // onSearch={this.getSearchResults.bind(this)}
                    onChange={(e) => this.getSearchResults1(e.target.value)}
                  />
                </div>
              
                <Popover
                  overlayClassName="popover-custom"
                  placement="top"
                  title={""}
                  content={"Refresh"}
                >
                  <figure
                    className="col m-auto"
                    onClick={this.refreshCard.bind(this)}
                  >
                    <img
                      src="/assets/images/icons/refresh.png"
                      alt="refresh"
                      draggable={false}
                    />
                  </figure>
                </Popover>
              </div>
           
            {/* <div className="b-card-scroll mb-3"> */}
            <div>
            
              {
                appointmentpatientlist.map((item) => {
                  
                  return (
                    <div>
                 
                    { this.state.QueueList?(
                    
                      
                      <OperatorCard
                        props={this.state.appointmentPatientDetails}
                        item={item}
                        datavalue={"true"}

                      />
                      ):(<p></p>)
                    }
                    </div>
                  );
                })}
            </div></div>
  
  </Tabs.TabPane>
</Tabs>
          
         

          </div>
        </div>
        {/* patients rooms */}
        <div className="col-9 col-lg-9 col-md-7">
          <div className="q-p-d-list w-100">
            <div className="card-row">
              
              {/* {QueueList && QueueList.map((item, key) => { */}
              {QueueList.map((item, key) => {
                return (

                  <div className="card-dynamic mr-2" key={key}  >
                                   {/* {console.log("iiitttteeeeemmmmm",item.roomnumber)} */}

                   
                    <DoctorCard
                      props={this.state}
                      {...this.props}
                      item={item}
                      queueDoctors={queueDoctors}
                      refreshData={this.refreshData.bind(this)}
                      refreshMultipleQueues={this.refreshMultipleQueues.bind(
                        this
                      )}
                      refreshQueueListData={this.refreshQueueListData.bind(
                        this
                      )}
                    />
            
                    <div
                      // onDrop={(files) => this.checkQType(files, item)}
                      onDrop={(files) => this.onFileDrop(files, item)}
                      class="PatientCardsDisplay b-card q-p-details pr-1"
                     
                    >
                      <QueuepatientDetailshell
                       department_ids={department_ids}
                        roomId={item.roomnumber}
                        setLatestCard={this.setLatestCard.bind(this)}
                        setLatestDropIndex={this.setLatestDropIndex.bind(this)}
                        {...this.props}
                        item={item}
                        props={this.state}
                        refreshMultipleQueues={this.refreshMultipleQueues.bind(
                          this
                        )}
                        refreshQueueListData={this.refreshQueueListData.bind(
                          this
                        )}
                        refreshData={this.refreshData.bind(this)}
                        activateLoader={this.activateLoader.bind(this)}
                        deActivateLoader={this.deActivateLoader.bind(this)}
                        isvitalsRequire_nullornot={this.isvitalsRequire_nullornot.bind(
                          this
                        )}
                        getSearchResults={this.getSearchResults.bind(this)}
                        setlastRefreshedAt={this.setlastRefreshedAt.bind(this)}
                      />
                  
                    </div>
                  </div>
                );
              })}
            </div>

            {this.state.isLoading && (
              <div className="loader">
                <Spin indicator={antIcon} tip="Loading..." />
              </div>
            )}
          </div>
        </div>
        {/* Vitals */}
          {/* <Modal
          visible={this.state.vitalsModalvisible}
          onOk={this.vitalshandleOKCancel}
          confirmLoading={this.state.confirmLoading}
          onCancel={this.vitalshandleOKCancel}
          footer={null}
        >
          <p>Required to measure vitals? </p>
          <div className="col-12 mb-3 text-center">
            {this.state.ModalError && (
              <small className="text-danger">
                Please select YES or NO.
              </small>
            )}
            {vitalsOptions.map((option) => (
              <Button
                className={`mx-4 ${option === "YES" && "btn-magenta"
                  }`}
                id={option}
                value={option}
                type={option === "YES" && "primary"}
                onClick={(e) =>
                  this.isVitalsRequired(
                    e,
                    // item.id //patient card
                    this.state.latestCardId.id,option
                  )
                }
              >
                
                {option}
              </Button>
            ))}
          </div>
        </Modal>   */}
        <Queuemodal
          {...this.props}
          {...this.state}
          onmodalChanges={this.modalChanges.bind(this)}
          refreshData={this.refreshData.bind(this)}
        />
      </div>
    );
  }
}

export default OperatorView;
// export { sockets };


//  {this.state.selectedOption=="patients"?(
//             <div>
//                     <div className="row mb-3">
//                         <div className="col-10 pr-0">
                 
//                           <Search
//                               value={this.state.searchVal}
//                               placeholder="Search here"
//                               allowClear={true}
//                     // onSearch={this.getSearchResults.bind(this)}
//                               onChange={(e) => this.getSearchResults(e.target.value)}
//                             />
//                         </div>
              
//                         <Popover
//                           overlayClassName="popover-custom"
//                           placement="top"
//                           title={""}
//                           content={"Refresh"}
//                         >
//                         <figure
//                           className="col m-auto"
//                           onClick={this.refreshCard.bind(this)}
//                         >
//                           <img
//                             src="/assets/images/icons/refresh.png"
//                             alt="refresh"
//                             draggable={false}
//                           />
//                         </figure>
//                         </Popover>
//                   </div>
            
//             <div className="b-card-scroll mb-3">
//               {/* <p>Hello World</p> */}
//               {
//                 displayPatients.map((item) => {
                  
//                   return (
//                     <>
                   
//                       <OperatorCard
//                         setLatestCard={this.setLatestCard.bind(this)}
//                         props={this.state}
//                         vitalsModalvisible={this.vitalsModalvisibility}
//                         vitalsRequired={this.state.vitalsRequired}
//                         {...this.props}
//                         roomId={null}
//                         item={item}
//                         datavalue={"false"}
//                         refreshData={this.refreshData.bind(this)}
//                         activateLoader={this.activateLoader.bind(this)}
//                         deActivateLoader={this.deActivateLoader.bind(this)}
//                         refreshMultipleQueues={this.refreshMultipleQueues.bind(
//                           this
//                         )}
//                         QType={QType && QType}
//                       />

//                     </>
//                   );
//                 })}
//             </div> </div>

//           ):(
        
          
//            <div>
//               <div className="row mb-3">
//                 <div className="col-10 pr-0">
                 
//                   <Search
//                     value={this.state.searchVal1}
//                     placeholder="Search here"
//                     allowClear={true}
//                     // onSearch={this.getSearchResults.bind(this)}
//                     onChange={(e) => this.getSearchResults1(e.target.value)}
//                   />
//                 </div>
              
//                 <Popover
//                   overlayClassName="popover-custom"
//                   placement="top"
//                   title={""}
//                   content={"Refresh"}
//                 >
//                   <figure
//                     className="col m-auto"
//                     onClick={this.refreshCard.bind(this)}
//                   >
//                     <img
//                       src="/assets/images/icons/refresh.png"
//                       alt="refresh"
//                       draggable={false}
//                     />
//                   </figure>
//                 </Popover>
//               </div>
           
//             <div className="b-card-scroll mb-3">
//               {/* <p>Hello World</p> */}
//               {
//                 appointmentpatientlist.map((item) => {
                  
//                   return (
//                     <>
                   
//                       <OperatorCard
//                         props={this.state.appointmentPatientDetails}
//                         item={item}
//                         datavalue={"true"}

//                       />

//                     </>
//                   );
//                 })}
//             </div></div>)}